import { SignatoryEdit } from '../../model/signatory-edit';
import { EditEnvelopeInformation } from './edit-envelope-information';
import { EditEnvelopeSignatories } from './edit-envelope-signatories';

export class EditEnvelope {
  editEnvelopeInformation: EditEnvelopeInformation;
  editEnvelopeSignatories: EditEnvelopeSignatories;
  editEnvelopeIsOrdered: boolean;
  editEnvelopeIsAccessAuthentication: boolean;

  generateSend(): EditEnvelopeToSend {
    const signatoriesToEdit: EditEnvelopeTosendSignatories[] = [];
    const filesToEdit: EnvelopeFileSend[] = [];
    if (this.editEnvelopeSignatories.listToEdit === undefined) {
      this.editEnvelopeSignatories.listToEdit = new Array();
    }

    for (const signatoryEdit of this.editEnvelopeSignatories.listToEdit) {
      signatoriesToEdit.push({
        envelopeSignatoryId: signatoryEdit.hasOwnProperty('envelopeSignatoryId')
          ? signatoryEdit.envelopeSignatoryId
          : null,
        signatureType: signatoryEdit.signatureType,
        subscriberType: signatoryEdit.subscriberType,
        order: signatoryEdit.order,
        needSaveToSignatory: false,
        IsEdited: signatoryEdit.isEdited,
        sendWhatsApp: signatoryEdit.sendWhatsApp,
        status: signatoryEdit.status,
        signatory: {
          id: signatoryEdit.id,
          name: signatoryEdit.name,
          ssn: signatoryEdit.ssn,
          mail: signatoryEdit.mail,
          signatureType: signatoryEdit.signatureType,
          subscriberType: signatoryEdit.subscriberType,
          active: true,
          allSegments: true, // futuramente verificar se na opção de salvar na agenda deve ser visto segmentos
          phoneNumber: signatoryEdit.phoneNumber,
          acceptWhatsApp: signatoryEdit.acceptWhatsApp,
          sendWhatsApp: signatoryEdit.sendWhatsApp,
          reuseSignatures: signatoryEdit.reuseSignatures,
          signatoryTypeRoleId: signatoryEdit.signatoryTypeRoleId,
        },
      });
    }
    this.editEnvelopeInformation.files.forEach((file) => {
      filesToEdit.push({
        id: file.id,
        name: file.name,
      });
    });

    const toSend = new EditEnvelopeToSend();
    toSend.id = this.editEnvelopeInformation.id;
    toSend.title = this.editEnvelopeInformation.title;
    toSend.isOrdered = this.editEnvelopeIsOrdered;
    toSend.language = this.editEnvelopeInformation.language;
    toSend.message = this.editEnvelopeInformation.message;
    toSend.reminderFrequency = this.editEnvelopeInformation.reminderFrequency;
    toSend.segmentId = this.editEnvelopeInformation.segmentId;
    toSend.accessAuthentication = this.editEnvelopeIsAccessAuthentication;
    toSend.expiration = this.editEnvelopeInformation.expiration;
    toSend.isRejectable = this.editEnvelopeInformation.isRejectable;
    toSend.files = filesToEdit;
    toSend.signatories = signatoriesToEdit;

    return toSend;
  }

  setInformation(information: any) {
    this.editEnvelopeInformation = {
      id: information.id,
      title: information.title,
      message: information.message,
      language: information.language.id,
      expiration: information.expiration
        ? information.expiration.singleDate.jsDate
        : undefined,
      segmentId:
        information.segment == undefined ? null : information.segment.id,
      reminderFrequency: information.reminderFrequency.id,
      isRejectable: information.isRejectable,
      files: information.files,
    };
  }

  setSignatory(
    elementsToEdit: Array<SignatoryEdit>,
    elementsIdsToRemove: number[]
  ): void {
    this.editEnvelopeSignatories = {
      listToEdit: elementsToEdit,
      listToRemove: elementsIdsToRemove,
    };
  }

  setIsOrdered(ordered: boolean): void {
    this.editEnvelopeIsOrdered = ordered;
  }

  setIsAccessAuthentication(accessAuthentication: boolean): void {
    this.editEnvelopeIsAccessAuthentication = accessAuthentication;
  }
}

export class EditEnvelopeToSend {
  id: number;
  title: string;
  isOrdered: boolean;
  language: number;
  message: string;
  reminderFrequency: number;
  segmentId: number;
  accessAuthentication: boolean;
  expiration: string;
  isRejectable: boolean;
  files: EnvelopeFileSend[];
  signatories: EditEnvelopeTosendSignatories[];
}

export class EditEnvelopeTosendSignatories {
  signatureType: number;
  subscriberType: number;
  order: number;
  envelopeSignatoryId?: number;
  signatory: Signatory;
  needSaveToSignatory: boolean;
  IsEdited: boolean;
  sendWhatsApp: boolean;
  status: number;
}

export class Signatory {
  id?: number;
  name: string;
  ssn: string;
  mail: string;
  signatureType: number;
  subscriberType: number;
  active: boolean;
  allSegments: boolean;
  phoneNumber: string;
  acceptWhatsApp: boolean;
  sendWhatsApp: boolean;
  reuseSignatures: boolean;
  signatoryTypeRoleId?: number;
}

export class EnvelopeFileSend {
  id?: number;
  name: string;
}
